import { NgModule } from "@angular/core";
import { HeaderComponent } from "./header.component";
import { NgOptimizedImage } from "@angular/common";
import { RouterLink } from "@angular/router";
import { MatMenu, MatMenuItem, MatMenuTrigger } from "@angular/material/menu";
import { TranslatePipe } from "@ngx-translate/core";

@NgModule({
  declarations: [HeaderComponent],
  exports: [HeaderComponent],
  imports: [NgOptimizedImage, RouterLink, MatMenuTrigger, MatMenu, MatMenuItem, TranslatePipe],
})
export class HeaderComponentModule {}
